var map = {
	"./bg/app.js": "./locale/bg/app.js",
	"./de/app.js": "./locale/de/app.js",
	"./en/app.js": "./locale/en/app.js",
	"./eo/app.js": "./locale/eo/app.js",
	"./es/app.js": "./locale/es/app.js",
	"./fr/app.js": "./locale/fr/app.js",
	"./it/app.js": "./locale/it/app.js",
	"./ja/app.js": "./locale/ja/app.js",
	"./ko/app.js": "./locale/ko/app.js",
	"./nl_NL/app.js": "./locale/nl_NL/app.js",
	"./pl_PL/app.js": "./locale/pl_PL/app.js",
	"./pt_BR/app.js": "./locale/pt_BR/app.js",
	"./ru/app.js": "./locale/ru/app.js",
	"./uk/app.js": "./locale/uk/app.js",
	"./zh_CN/app.js": "./locale/zh_CN/app.js",
	"./zh_HK/app.js": "./locale/zh_HK/app.js",
	"./zh_TW/app.js": "./locale/zh_TW/app.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./locale recursive ^(?!.*(?:index.js$)).*\\.js$";


//////////////////
// WEBPACK FOOTER
// ./locale ^(?!.*(?:index.js$)).*\.js$
// module id = ./locale recursive ^(?!.*(?:index.js$)).*\.js$
// module chunks = locale